//
//
//
//
import contractList from '../contractList/list';
export default {
  components: {
    contractList: contractList
  }
};